import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-all-toast',
  templateUrl: './toggle-all-toast.component.html',
  styleUrls: ['./toggle-all-toast.component.scss'],
  standalone: false,
})
export class ToggleAllToastComponent {
  @Input() showToast = false;
  @Input() toastMessage = '';
  @Output() dontShowAgainChange = new EventEmitter<{
    checked: boolean;
    message: string;
  }>();
  @Output() closeToast = new EventEmitter<void>();

  onDontShowAgainChange(event: any) {
    this.dontShowAgainChange.emit({
      checked: event.detail.checked,
      message: this.toastMessage,
    });
  }

  onClose() {
    this.closeToast.emit();
  }
}
